import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskInspectionOtherIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            d='M12 15.584c.544 0 1.016.2 1.416.6.4.4.6.872.6 1.416 0 .544-.2 1.016-.6 1.416-.4.4-.872.6-1.416.6-.544 0-1.016-.2-1.416-.6-.4-.4-.6-.872-.6-1.416 0-.544.2-1.016.6-1.416.4-.4.872-.6 1.416-.6zm0-6c.544 0 1.016.2 1.416.6.4.4.6.872.6 1.416 0 .544-.2 1.016-.6 1.416-.4.4-.872.6-1.416.6-.544 0-1.016-.2-1.416-.6-.4-.4-.6-.872-.6-1.416 0-.544.2-1.016.6-1.416.4-.4.872-.6 1.416-.6zm0-1.968c-.544 0-1.016-.2-1.416-.6-.4-.4-.6-.872-.6-1.416 0-.544.2-1.016.6-1.416.4-.4.872-.6 1.416-.6.544 0 1.016.2 1.416.6.4.4.6.872.6 1.416 0 .544-.2 1.016-.6 1.416-.4.4-.872.6-1.416.6z'
        />
    ),
})

TaskInspectionOtherIcon.displayName = 'TaskInspectionOtherIcon'
